import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { environment } from '../../environments/environment';
import { IReportJwtPayload } from '../utils/JwtUtils';

@Injectable({
  providedIn: 'root',
})
export class AmplitudeService {
  initAmplitude() {
    amplitude.add(sessionReplayPlugin({ sampleRate: 0.15 }));

    amplitude.init(environment.amplitudeApiKey, {
      serverZone: 'EU',
      autocapture: {
        attribution: false,
        pageViews: true,
        sessions: true,
        formInteractions: true,
        fileDownloads: true,
        elementInteractions: true,
      },
      minIdLength: 1,
    });
  }

  trackEvent(eventName: string, eventData?: any) {
    amplitude.track(eventName, eventData);
  }

  setUserId(userId: string) {
    amplitude.setUserId(userId);
  }

  setUserProperty(property: string, value: string) {
    const identifyEvent = new amplitude.Identify();
    identifyEvent.set(property, value);
    amplitude.identify(identifyEvent);
  }

  setGroup(property: string, value: string) {
    amplitude.setGroup(property, value);
  }

  // PBI #2232 (TC-11): gemeinsame Identifikation nach erfolgreichem Login - bisher nur in
  // login.component.ts, dadurch blieben Benutzer nach der OTP-Verifizierung (automatischer
  // Login, TC-08-2) in Amplitude anonym. Inhalt bewusst unveraendert uebernommen.
  identifyUserAndTrackSignIn(jwt: IReportJwtPayload) {
    const { userid, email, companyid, companyname } = jwt;
    this.setUserId(userid);
    this.setUserProperty('email', email);
    this.setGroup('companyId', companyid);
    this.setGroup('companyName', companyname);
    this.trackEvent('Sign In');
  }
}
